module.exports = "<itpx-uploader\n    [cancelRoute]='cancelRoute'\n    [component]='component'\n    [saveRoute]='saveRoute'\n    [type]=\"allowedTypes\"    \n    [imgSrc]='imgSrc'\n    [bucket]=\"bucket\"\n    (unsavedData)=\"unsavedData($event)\">\n</itpx-uploader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/organization-details/organization-details-edit/update-print-logo/update-print-logo.component.html
// module id = ./src/app/organization/components/organization-details/organization-details-edit/update-print-logo/update-print-logo.component.html
// module chunks = main